import { Box, Button, Typography, useTheme } from '@mui/material';
import { tokens } from '../theme';
import { ShoppingCartIcon } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import { Link } from 'react-router-dom';

const Header = ({ title, subtitle, Icon, iconBackground }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const colors = tokens(theme.palette.mode);

  return (
    <Box display="flex" alignItems="center" width="100%" mb="30px">
     {Icon && (
        iconBackground ? (
          <Box
            sx={{
              width: 60,
              height: 60,
              bgcolor: '#2C2C2C',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mr: 2,
            }}
          >
            <Icon sx={{ color: '#fff', fontSize: 42 }} />
          </Box>
        ) : (
          <Icon sx={{ color: '#2C2C2C', fontSize: 42 }} />
        )
      )}
      <Box>
        <Typography variant="h2" color={colors.grey[100]} fontWeight="bold" sx={{ m: '0 0 5px 0' }}>
          {title}
        </Typography>
        <Typography variant="h3" color={colors.grey[400]}>
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;
